import { get } from "..//common/query";

export const GET_ISSUE = data => get("/question/list", data);
